import { apiClient } from '@/lib/api/api-client'
import { Bed } from '../types/bed'

const DEPARTMENT_ENDPOINT = '/departments'

export const bedApi = {
  getBeds: (departmentId: string) => {
    return apiClient.get<Bed[]>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds`)
  },

  getBed: (departmentId: string, bedId: string) => {
    return apiClient.get<Bed>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds/${bedId}`)
  },

  createBed: (departmentId: string, payload: any) => {
    return apiClient.post<Bed>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds`, payload)
  },

  updateBed: (departmentId: string, bedId: string, payload: any) => {
    return apiClient.put<Bed>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds/${bedId}`, payload)
  },

  deleteBed: (departmentId: string, bedId: string) => {
    return apiClient.delete<Bed>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds/${bedId}`)
  },

  assignBed: (departmentId: string, bedId: string, payload: any) => {
    return apiClient.patch<Bed>(`${DEPARTMENT_ENDPOINT}/${departmentId}/beds/${bedId}/assign`, payload)
  },
}
